import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { BroadcastService } from '@services/broadcast-service';
import { AiAssistantMessage, OPEN_AI_ASSISTANT_EVENT } from '@services/ai-assistant-chat-service/ai-assistant-chat.types';

const PARENT_ID_KEY_BY_CLASS: Record<string, string> = {
  ConsultationSession: 'consultationSessionId',
  Order: 'orderId',
  SupportTicket: 'supportTicketId',
  FollowUp: 'followUpId',
};

@Injectable({ providedIn: 'root' })
export class AiAssistantService {
  private readonly broadcast = inject(BroadcastService);

  requestOpen(options?: { initialMessage?: string }): void {
    this.broadcast.broadcast(OPEN_AI_ASSISTANT_EVENT, options);
  }

  onOpenRequested(): Observable<{ initialMessage?: string } | undefined> {
    return this.broadcast.on(OPEN_AI_ASSISTANT_EVENT);
  }

  buildParentContext(message?: AiAssistantMessage | null): Record<string, string> {
    const parentId = message?.context?.['parentId'] as string | undefined;
    const parentClassName = message?.context?.['parentClassName'] as string | undefined;
    const idKey = parentClassName ? PARENT_ID_KEY_BY_CLASS[parentClassName] : undefined;
    return parentId && idKey ? { [idKey]: parentId } : {};
  }
}
